<template>
    <form style="position: relative">
      <div style="position:absolute; top: 10px; right: 10px;">
      <CopyBlock :sharedData="sharedData" />
      </div>
      <h2>{{ $t('Add.Ruleset.Ruleset') }}</h2>
      <NameProp :sharedData="sharedData" />
      <p class="pseudoLabel" >{{ $t('Add.Ruleset.SetConditions') }}</p>
      <div class="divider" v-for="(condition, index) in conditions" :key="index">
      <div class="conditions"  @click=" setPreviewIndex(index)">
        <!-- Einklappen/Ausklappen -->
        <button class="toggle-button" type="button" @click.prevent="toggleCondition(index)">
          <span class="material-symbols-outlined">
            {{ condition.expanded ? 'expand_less' : 'expand_more' }}
          </span>
        </button>
        <!--Name of condition -->
        <div class="conditionName" v-if="!condition.expanded">
          {{ sharedData.data.props.rules[index]?.conditionName ||`Condition ${index + 1}`}}
        </div>
        <!-- Delete Condition -->
        <button class="delete-button" type="button" @click="removeCondition(index)">
          <span class="material-symbols-outlined">delete</span>
        </button>
        <!-- Condition Preview -->
        <div v-if="!condition.expanded" class="conditionPreview">
          <div v-if="sharedData.data.props.rules[index].condition.trim() && !sharedData.data.props.rules[index].fullCondition">
            {{ `${this.sharedData.data.props.rules[index].statement} ${sharedData.data.props.rules[index].condition}`}}</div>
            <div v-else-if="sharedData.data.props.rules[index].fullCondition"><span class="material-symbols-outlined">
discover_tune
</span></div> 
          <div v-else>{{ $t('Add.Ruleset.noCondition') }}</div> 
        </div>
        <!-- Condition Content -->
        <div v-if="condition.expanded">
          <label class="contentLabel" for="conditionName">{{ $t('Add.Ruleset.ConditionName') }}</label>
            <input
              type="text"
              id="conditionName"
              v-model="condition.conditionName"
              placeholder="enter name"
        />
            <label class="contentLabel" for="statement">{{ $t('Add.Ruleset.SetStatement') }}</label>
            <select v-model="sharedData.data.props.rules[index].statement">
              <option v-for="placeholder in placeholders" :key="placeholder" :value="placeholder">
                {{ placeholder }}
              </option>
            </select>
          <label class="ifThen"><em>{{ $t('Add.Ruleset.If') }}</em></label>

          <!-- Dropdown for operators -->
          <select v-model="condition.operator" class="operator-select">
            <option value="=">=</option>
            <option value="!=">!=</option>
            <option value="<">&lt;</option>
            <option value=">">&gt;</option>
            <option value="else">{{ $t('Add.Ruleset.else') }}</option>
          </select>

          <!-- Input for the value -->
          <input v-if="sharedData.data.props.rules[index].operator !== 'else'" type="text" v-model="condition.value" placeholder="Value eingeben" />

          <label class="ifThen"><em>{{ $t('Add.Ruleset.Then') }}</em></label>
          <div v-if="!sharedData.data.props.rules[index].conditionalBlock">
            <ul>
              <!-- Block Auswahl -->
              <li @click="handleClick('Text', index)">
                <span class="material-symbols-outlined addIcon">text_fields</span>Text
              </li>
              <li @click="handleClick('Heading', index)">
                <span class="material-symbols-outlined addIcon">format_h1</span>Haeding
              </li>
            <li @click="handleClick('Image', index)">
                <span class="material-symbols-outlined addIcon">image</span>Image
            </li>
            <li @click="handleClick('Html',index)">
                <span class="material-symbols-outlined addIcon">html</span>HTML
            </li>
            <li @click="handleClick('Ruleset',index)">
                <span class="material-symbols-outlined addIcon">rule</span>Ruleset
            </li>
            
        </ul>
        </div>
        <div class="blockDisplay" v-else>
        <div 
        class="displayedBlock"
        @click.stop = "setPreviewIndex(index), 
                      shareProps(sharedData.data.props.rules[index].conditionalBlock, 
                      emailData[sharedData.data.props.rules[index].conditionalBlock])" > 
           {{ emailData[sharedData.data?.props?.rules[index]?.conditionalBlock]?.type || '' }} Block
        </div>
        <div class="deleteDisplayedBlock"><span class="material-symbols-outlined" @click.stop="removeConditionalBlock(index)">close</span>
        </div>
      </div>
      <!-- Open Modal Button -->
      <button class="open-modal-button" @click.prevent="openModal = true, modalIndex = index">
        {{ $t('Add.Ruleset.AdvandcedMode') }}
          </button>
          <span style="color:red; font-size: 20px; margin-left: 5px;" v-if="sharedData.data.props.rules[index].fullCondition"><strong>!</strong></span>
        </div>
      </div>
    </div>
      <div class="divider">
        <button type="button" @click="addCondition">
          <span class="material-symbols-outlined">add</span> {{ $t('Add.Ruleset.AddCondition') }}
        </button>
      </div>
      <ConditionModal 
        v-if="openModal" 
        :sharedData = sharedData
        :conditionIndex = modalIndex
        @close="openModal = false"
        />
    </form>
  </template>
 <script>
 import { mapActions, mapGetters, mapState} from 'vuex';
 import ConditionModal from '../Reusables/ConditionModal.vue';
 import RulesetTree from '../Reusables/RulesetTree.vue';
 import { isNameUnique } from '@/utils/isNameUnique';
import NameProp from './AddProps/NameProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
 export default {
   name: "AddRuleset",
   components: { ConditionModal, RulesetTree, NameProp, CopyBlock },
   props: ["sharedData"],
   data() {
     return {
       isUniqueName: true,
       conditions: this.sharedData?.data?.props?.rules || [],
       openModal: false,
       modalIndex: null
     };
   },
   computed: {
    ...mapState(['xPathPlaceholders']),
    ...mapGetters(['getEmailData']),
    emailData() {
      return this.getEmailData;
    },
    placeholders() {
      return this.xPathPlaceholders.map(item => item.placeholder);
   }},
   methods: {
    ...mapActions(['updateActiveTab', 'updateAddState', 'addNewBlock', 'updateSharedData']),
    toggleCondition(index) {
      this.conditions[index].expanded = !this.conditions[index].expanded;
    },
    async handleClick(item, index) {
      this.updateActiveTab ('Inspect')
      this.updateAddState(item);
      await this.addNewBlock({
        type: item,
        targetId: null,
        position: 'bottom',
        parentId: this.sharedData.id,
        parentType: 'Container'
      });
      const newBlockIndex = this.sharedData.data.props.childrenIds.length -1
      this.sharedData.data.props.rules[index].conditionalBlock = this.sharedData.data.props.childrenIds[newBlockIndex]
      },
      shareProps(id, data) {
        console.log({id, data})
        this.updateSharedData({id, data});
      },
      setPreviewIndex(index){
        this.sharedData.data.props.previewIndex = index;
      },
      removeConditionalBlock(index) {
      // Entferne den conditionalBlock und aktualisiere die childrenIds
      const blockId = this.sharedData.data.props.rules[index].conditionalBlock;
      const blockIndex = this.sharedData.data.props.childrenIds.indexOf(blockId);
      if (blockIndex !== -1) {
        this.sharedData.data.props.childrenIds.splice(blockIndex, 1);
      }
      this.sharedData.data.props.rules[index].conditionalBlock = null;
    },
     addCondition() {
       this.conditions.push({statement:"", conditionName:"", condition: "", operator: "", value: "", conditionalBlock: "" });
     },
     removeCondition(index) {
      
       this.conditions.splice(index, 1);
     },
     saveRuleset() {
       this.sharedData.data.props.conditions = this.conditions;
       // Weitere Logik zum Speichern
     },
     closeComponent() {
       this.$emit("close");
     },
   },
   mounted(){
    this.isUniqueName = isNameUnique(this.sharedData.data.props.name, this.sharedData.id);
   },
   watch: {
      conditions: {
        handler(newConditions) {
         newConditions.forEach(condition => {
            // Erstelle den zusammengefügten String aus Operator und Wert
        condition.condition = `${condition.operator} ${condition.value}`;
      });
    },
    deep: true,
  },
  }
 };
 </script>
<style scoped>
 @import '../../styles/addComponents.css';

input[type="text"] {
  width: calc(100% - 10px);
  padding: 10px 5px;
  font-size: 16px;
  border: none;
  border-bottom: 2px solid #ccc;
  background: none;
  outline: none;
  margin-bottom: 15px;
}

button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  font-size: 14px;
  background-color: transparent;
  color: black;
  border: 1px solid #ccc;
  transition: background-color 0.3s;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: rgb(241, 238, 238);
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.conditions {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 10px;
  padding-top: 35px;
}
.conditions:hover {
  border: 1px solid black;
}

ul {
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

li {
  font-size: 12px;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
  padding-top: 5px;
}

li:hover {
  background-color: #f0f0f0; 
} 

.addIcon {
  background:  var(--secondary-color);
  color: white;
  font-size: 30px;
  padding: 3px 5px;
  margin: 0px;
  margin-bottom: 5px;
}

.conditionPreview{
  font-style: italic;
  color: darkgray;
  font-size: 14px;
}

.blockDisplay{
  display: flex; 
}

.displayedBlock {
  padding: 10px;
  padding-left: 5px;
  width: 75%
}

.deleteDisplayedBlock{
  width: 20%;
}

.deleteDisplayedBlock:hover{
  cursor: pointer;
}

.displayedBlock:hover{
  background-color: #e0e0e0;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.ifThen {
  font-size: 14px;
}

.delete-button, .toggle-button{
  padding: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
  background: transparent;
  color: black;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.3s;
  z-index: 10;
}

.delete-button:hover {
  background: transparent;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
}

.toggle-button {
  position: absolute;
  top: 5px;
  left: 5px;
}

.open-modal-button {
  margin-top: 10px;
  background-color: transparent;
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
}

.divider{
  margin-bottom: 10px;
}

</style>  